<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container-fluid">
        <div class="page-title-content">
            <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">Outbound Marketing</h2>
            <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                <li><a (click)="goPlaces()">Home</a></li>
                <li>Outbound Marketing</li>
            </ul>
        </div>
    </div>

</div>
<!-- <div class="aboutus-hb__control_panel">
    <div class="aboutus-hb__yearline">
        <div class="aboutus-hb__yearline_track">
            <div
            class="page-heading"
            style="
                height: 150px;
                text-align: center;
                color: #fffefe;
                margin-bottom: 40px;
               
            "
        >
            <h1>
                <b>Automated Speech Tools Transform Outbound Marketing Strategies</b
                >
            </h1>
             
        </div>
        </div>
    </div>
     
</div> -->

<section class="team-area">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                   
                </div> -->
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/outbound-outreach.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Automated Outreach
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Vocbot has the capability to make outbound calls that can be used for sales and promotions,
                            sending updates, surveys, and many more purposes by initiating proactive communication with
                            potential customers.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Lead Qualification
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Vocbot engages with leads to gather relevant information. Through interactive conversations,
                            it qualifies leads based on criteria such as interests, budget, and readiness to purchase.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/lead-scoring.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/outbound-track.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Campaign Tracking and Analytics
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Vocbot can conduct outbound marketing campaigns, and monitor and track user responses,
                            conversion rates, and other metrics, providing valuable insights for campaign optimization.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>



</section>
<!-- <section class="team-area ptb-110">

<div
    class="page-heading"
    data-aos="fade-down"
    data-aos-easing="linear"
    data-aos-duration="1200"
    style="
        height: 150px;
        text-align: center;
        color: #000000;
        margin-bottom: 40px;
        text-transform: uppercase;
    "
>
    <h1>
        <b>Automated Speech Tools Transform Outbound Marketing Strategies</b>
    </h1>
    <img src="assets/img/RO.gif" style="height: 35px" />
</div>


<div class="container-fluid"  >
    <div class="row">

        <div class="row member-content">
            <div class="col-lg-12 col-md-12">

                
                <div class="row row-margin-1" data-aos="zoom-in">
                    <div class="col-sm-12 col-md-4  col-lg-4 member-thumb-1 ">
                        <img  src="assets/img/outbound-outreach.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-8 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                        
                            <p class="title mb-2">Automated Outreach</p>
                            
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Vocbot  initiate proactive communication with potential customers.
                                They send personalized messages, promotions, or updates based on user preferences and behavior.</p>
                        </div>
                    </div>
                </div>

               

    
                <div class="row row-margin-2 mobile-margin-top" data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Lead Qualification</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">  Vocbot  engage with leads to gather relevant information.
                                Through interactive conversations, they qualify leads based on criteria such as interests, budget, and readiness to purchase.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2  order-sm-1 order-xs-1 order-1 ">
                        <img src="assets/img/outbound-lead.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>


             
                <div class="row row-margin-1  mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1  ">
                        <img  src="assets/img/outbound-track.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8  mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Campaign Tracking and Analytics</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Vocbot  monitor the performance of outbound marketing campaigns.
                                They track user responses, conversion rates, and other metrics, providing valuable insights for campaign optimization.</p>
                        </div>
                    </div>
                </div>
 </div>
        </div>
    
    </div>
</div>
</section> -->


















<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/outbound-outreach.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Automated Outreach</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  initiate proactive communication with potential customers.
They send personalized messages, promotions, or updates based on user preferences and behavior.
                </p>
            </div>
        </div>
    </div>
</div>

<div
    class="container-fluid"
    style="background-image: url(assets/img/corner.jpg); background-size: cover"
>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-1 order-2">
            <div
                class="content"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <h3><b>Lead Qualification</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  engage with leads to gather relevant information.
                    Through interactive conversations, they qualify leads based on criteria such as interests, budget, and readiness to purchase.
                </p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-2 order-1">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 80%"
                    src="assets/img/outbound-lead.png"
                    alt="image"
                />
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 80%"
                    src="assets/img/outbound-track.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Campaign Tracking and Analytics</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  monitor the performance of outbound marketing campaigns.
They track user responses, conversion rates, and other metrics, providing valuable insights for campaign optimization.
                </p>
            </div>
        </div>
    </div>
</div> -->











































<!-- Start Outbound Marketing Area -->
<!-- <section class="features-area ptb-110">
    <div class="container">
        <div class="overview-box">
            
            <div class="content">
                <h3>
                    Outbound Marketing:
                </h3>
                <p>Elevate your outbound marketing endeavors with the powerful capabilities of Vocbot .This invaluable tool enhances efficiency through various features. Experience seamless scalability, allowing you to transition effortlessly.</p>

                <ul class="features-lists">
                    <li>
                        <span>
                            <i class="bx bx-check-double"></i> 
                        <strong>Automated Outreach:</strong><br>
                        Vocbot  facilitates automated outbound marketing efforts, reaching a wider audience efficiently.
                        
                        </span>
                    </li>
                    <li>
                        <span>
                            <i class="bx bx-check-double"></i> 
                        <strong>Scalability: </strong><br>
                        Seamlessly transition from zero to high-volume outbound calls with Vocbot 's scalable solutions.
                         
                        </span>
                    </li>
                    <li>
                        <span>
                            <i class="bx bx-check-double"></i> 
                        <strong>24/7 Availability: </strong><br>
                        Ensure round-the-clock marketing activities with Vocbot , enhancing outreach regardless of time zones.
                        </span>
                    </li>
                    <li>
                        <span>
                            <i class="bx bx-check-double"></i> 
                        <strong>Cost-Efficiency: </strong><br>
                        Vocbot  incurs minimal operational expenses, offering a cost-effective solution for outbound marketing.
                        </span>
                    </li>
                </ul>
            </div>

            <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/img/digital-marketing.png" alt="image">
            </div>
        </div>

    </div>
</section> -->
<!-- End Services Details Area -->